import {
  useInfiniteQuery,
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";
import { api } from "../../api";
import { IMeta } from "../../interfaces/Metas";

interface IResponseInstruments {
  data: string[];
  totalElements: number;
  totalPages: number;
}

export interface IQueryInstruments {
  idProduct?: number;
  page?: number;
  symbol?: string;
}

const getInfinitInstruments = async (
  { page, symbol, idProduct }: IQueryInstruments,
  pageParam: number = 1,
  signal?: AbortSignal
) => {
  const { data } = await api.get<IResponseInstruments>(
    `/web/product/${idProduct}/instruments`,
    {
      signal,
      params: {
        pageSize: 50,
        page: pageParam,
        sortOrder: "ASC",
        orderBy: "symbol",
        ...(symbol && { symbol: symbol }),
      },
    }
  );

  return {
    data: data.data,
    nextPage: pageParam + 1,
    hasMore: data.totalElements > data.data.length, // Determina se há mais dados
  };
};

export const useInfiniteInstruments = (params: IQueryInstruments) => {
  return useInfiniteQuery(
    ["Instruments", params],
    ({ pageParam = 1, signal }) =>
      getInfinitInstruments(params, pageParam, signal),
    {
      getNextPageParam: (lastPage) =>
        lastPage.hasMore ? lastPage.nextPage : undefined,
    }
  );
};
